// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ToolbarContract = contract({
  name: "Toolbar",
  description: "ANY three-region chrome bar — the leading/center/trailing pattern Apple HIG\ndescribes as a \"Toolbar.\" App window chrome (Reddit, Twitter, GitHub, Linear,\nmost desktop apps), section toolbars inside Cards or panels, bottom action\nbars on mobile layouts, persistent footer toolbars.\n\nDon't hand-roll `<Row justify=\"between\">` with a flex-1 on a middle child and\nmanual min-width juggling — Toolbar gives you the canonical `auto 1fr auto`\ngrid for free, with `role=\"toolbar\"`, `data-gds-part` markers, position\nvariants for top/bottom borders, and sticky sizing.\n\nSlot semantics:\n  leading   — Logo + nav rail (e.g. a `<Row>` of Buttons or Link components)\n  center    — Search input, page title chip, segmented Tab strip\n  trailing  — Icon buttons, notification bell, avatar, primary CTA\n\nWhen a slot is omitted, its column collapses cleanly. Center stays visually\ncentered in the bar regardless of leading/trailing widths because the grid\ntemplate is `auto 1fr auto` (the center column absorbs available width).\n\nUse as the top child of `<AppShellHeader>` for window-level chrome:\n  <AppShellHeader>\n    <Toolbar leading={<Logo/>} center={<Search/>} trailing={<Avatar/>} />\n  </AppShellHeader>\n\nUse directly inside a Card or page section for section-scoped toolbars:\n  <Card>\n    <Toolbar size=\"sm\" variant=\"subtle\" leading={...} trailing={...} />\n    {content}\n  </Card>",
  import: "@gradeui/ui",
  subcomponents: ["ToolbarSlot"],
  composesWith: ["Button","Avatar","Input","Logo","Badge","AppShellHeader","Card","Row","Stack"],
  styleDefaults: {"ToolbarSlot":"flex items-center min-w-0"},
  props: {
  "leading": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "left-aligned region (logo + primary nav)",
  },
  "center": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "center region (search, page title, segmented control)",
  },
  "trailing": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "right-aligned region (action icons, avatar, primary CTA)",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "escape hatch; bypasses slot layout",
  },
  "position": {
      schema: z.enum(["top", "bottom", "inline"]).optional(),
      design: "knob",
      description: "border placement",
      default: "top",
  },
  "variant": {
      schema: z.enum(["default", "subtle", "transparent"]).optional(),
      design: "knob",
      default: "default",
  },
  "size": {
      schema: z.enum(["sm", "md", "lg"]).optional(),
      design: "knob",
      description: "height + padding",
      default: "md",
  },
  "sticky": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "pin to top/bottom of scroll container",
      default: false,
  },
  "aria-label": {
      schema: z.string().optional(),
      design: "content",
      description: "required by WAI-ARIA toolbar pattern",
      default: "Toolbar",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
